import CustomInput from "../../components/CustomInput";

const QuotationControls = ({
    specialist,
    setSpecialist,
    email,
    setEmail,
    phone,
    setPhone,
    customPricing,
    setCustomPricing,
}) => {
    return (
        <div className="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-4 md:gap-6 w-full">
            <div className="flex flex-col md:flex-row items-stretch md:items-center gap-4 md:gap-6 w-full lg:flex-1">
                <div className="w-full lg:max-w-[400px]">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Tên chuyên viên
                    </label>
                    <CustomInput
                        type="text"
                        value={specialist}
                        onChange={setSpecialist}
                        placeholder="Nhập tên chuyên viên"
                        height="44px"
                    />
                </div>

                <div className="w-full lg:max-w-[400px]">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Email
                    </label>
                    <CustomInput
                        type="email"
                        value={email}
                        onChange={setEmail}
                        placeholder="email@example.com"
                        height="44px"
                    />
                </div>

                <div className="w-full lg:max-w-[400px]">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Số điện thoại
                    </label>
                    <CustomInput
                        type="text"
                        value={phone}
                        onChange={setPhone}
                        placeholder="Nhập số điện thoại"
                        height="44px"
                    />
                </div>
            </div>

            <label
                className={`block cursor-pointer p-4 rounded-[16px] border transition-colors w-full lg:w-auto shrink-0 ${customPricing
                    ? "bg-[#DCEAFF] border-[#9EC4FF]"
                    : "bg-[#EAEAE7] border-[#CFCECE] hover:bg-[#EAEAE7]/80"
                    }`}
            >
                <div className="flex items-center gap-3 group">
                    <div className="relative">
                        <input
                            type="checkbox"
                            checked={customPricing}
                            onChange={(e) => setCustomPricing(e.target.checked)}
                            className="sr-only peer"
                        />
                        <div
                            className={`w-11 h-6 rounded-full border transition-all ${customPricing
                                ? "bg-[#0267FF] border-[#0267FF]"
                                : "bg-[#A4A4A4] border-[#CBCBCB]"
                                }`}
                        />
                        <div
                            className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-all ${customPricing ? "translate-x-5" : ""
                                }`}
                        />
                    </div>

                    <div className="flex-1">
                        <span
                            className={`font-semibold transition-colors ${customPricing
                                ? "text-[#0267FF]"
                                : "text-gray-800 group-hover:text-[#0267FF]"
                                }`}
                        >
                            Báo giá riêng
                        </span>
                        <p
                            className={`text-sm transition-colors ${customPricing ? "text-[#3183FF]" : "text-[#52525B]"
                                }`}
                        >
                            Cho phép chỉnh sửa giá thủ công
                        </p>
                    </div>
                </div>
            </label>
        </div>
    );
};

export default QuotationControls;
